export interface LocalMetricEvent
{
  metric: string;
  amount: number;
  param?: string;
}

type MetricSink = ( events: LocalMetricEvent[] ) => void;

export class LocalMetrics
{
  private static sinks = new Set<MetricSink>();
  private static session_level_streak = 0;

  public static addSink( sink: MetricSink ): () => void
  {
    this.sinks.add( sink );
    return () => this.sinks.delete( sink );
  }

  public static report( events: LocalMetricEvent[] ): void
  {
    const valid = events.filter( e => Number.isFinite( e.amount ) && e.amount > 0 );
    if ( valid.length === 0 ) return;
    for ( const sink of this.sinks )
    {
      try { sink( valid ); } catch ( e ) { console.warn( "[LocalMetrics] sink failed", e ); }
    }
  }

  public static resetSessionStreak(): void
  {
    this.session_level_streak = 0;
  }

  public static bumpSessionStreak(): number
  {
    this.session_level_streak++;
    return this.session_level_streak;
  }
}
